import React, { useEffect, useCallback, useState} from 'react';
import PresetsExplorer from "components/installation/PresetsExplorer.js";
import WetSlider from "components/effects/WetSlider.js";
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import FormantEffect from "components/instruments/fm/FormantEffect.js";
import {connect} from 'react-redux';
import FormantsEditor from "components/instruments/fm/FormantsEditor.js";
import './multi-filter.scss';

const MultiFilter = ({showPresets, formant, effect, sequencerEngine}) => { 
    let side =  showPresets ? 
            <PresetsExplorer
              isPianoRoll={false}
              initialSize={10}
              oscillator={effect}
              track={effect}
              content={effect.preset}
              searchText={""}
              type={"formants"}/> :
    (formant &&
     <FormantEffect
                 sequencerEngine={effect.sequencerEngine}
       formant={formant}/>);

    return (<div className="multi-filter">
              <div className="multi-inner">
              <FormantsEditor
                oscillator={effect}/>
                {side}
             </div>
              <EffectParameterSlider
                name='Gain'
                sequencerEngine={sequencerEngine}
                lfoEnabled={true}
                parameter={effect.gainParameter}
                isParameter={true}
                step={0.1}
                max={6}
                min={0.1}
              />
              <WetSlider
                sequencerEngine={sequencerEngine}
                effect={effect}/>
            </div>            
           );
}

const mapStateToProps = (state, props) => {
  return {
      formant: state.instruments.showFormantEffect,
        showPresets: state.instruments.showFormantPresets
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiFilter);
